import { ThemeProvider, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { ContentTheme } from './ContentTheme';
import ContentHorizontalCardSkeleton from './ContentHorizontalCardSkeleton';
import ContentViewMoreHeader from './ContentViewMoreHeader';

export default function ContentViewMoreSkeleton() {
  const theme = useTheme();

  return (
    <ThemeProvider theme={ContentTheme}>
      <Box
        id='content-view-more-skeleton'
        sx={{
          [theme.breakpoints.up('md')]: {
            padding: theme.spacing(4),
          },
        }}
      >
        <ContentViewMoreHeader />
        <ContentHorizontalCardSkeleton />
      </Box>
    </ThemeProvider>
  );
}
